module.exports = __webpack_public_path__ + "static/img/plato.8ecb6c7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plato.gif
// module id = rBcd
// module chunks = 4